import { DisplayTime } from 'common/display-state/display-time.js';
import { ListInlineIconItem } from 'common/grid-list-items/list-inline-icon-item.js';
import { Reference } from 'common/reference/reference.js';
import { IMapSlotClose, TitleBodyHeaderEl } from 'common/tile/tile-body-header-v2-element.js';
import { Tile } from 'common/tile/tile.js';
import { LinkRef } from 'components-modules/condition/link-ref.js';
import { IMarkerModule } from 'components/map/slots/map-main-slot-marker-module-factory.js';
import { IModule } from 'redux-state/layout/types.js';
import { IPressure } from 'types/location.js';
import { WeatherStationLocationType } from 'types/markerTypes/marker.weatherStation.js';
import { IImageLinkCore } from 'utilities/image/image.js';
import { isNotNullOrUndefined } from 'utilities/isType.js';
import { NA_VALUE } from 'utilities/weather-station/location.js';
import {
  StationDescriptionClothingItem,
  StationDescriptionSoilMoistureItem,
  StationDescriptionSoilTemperatureItem,
  StationDescriptionWindObsItem,
} from './station-description-item.js';

export type StationDescriptionProps = IMarkerModule<WeatherStationLocationType>;

export const StationDescription = (props: IModule<StationDescriptionProps & IMapSlotClose>) => {
  const { title, markerModuleProps, weatherStationUrl, onModuleClose } = props.config;
  if (markerModuleProps) {
    const { attribution: attr, value } = markerModuleProps;
    const { temp, wind, pressure, humidity, rainfall, clothing, issuedAt } = value;
    const attribution: IImageLinkCore | undefined = attr;
    const pressureValue = (pressure && (pressure as IPressure).atSeaLevel) || null;
    return (
      <Tile dataModule="station-description" {...props}>
        <div className="Tile-body">
          <div className="Tile-body-header u-mB-sm">
            <TitleBodyHeaderEl title={title} onModuleClose={onModuleClose} displaySmallHeader={true} />
          </div>
          <div className="grid-list">
            <StationDescriptionClothingItem clothing={clothing} />
            {isNotNullOrUndefined(temp) && temp !== NA_VALUE && (
              <ListInlineIconItem v={1} icon="temperature" title="Temperature">
                <span>{`${temp}°`}</span>
              </ListInlineIconItem>
            )}
            {isNotNullOrUndefined(rainfall) && (
              <ListInlineIconItem v={1} icon="rainfall" title="Rainfall">
                <span>{`${rainfall}mm`}</span>
              </ListInlineIconItem>
            )}
            {isNotNullOrUndefined(humidity) && (
              <ListInlineIconItem v={1} icon="humidity" title="Humidity">
                <span>{`${humidity}%`}</span>
              </ListInlineIconItem>
            )}
            <StationDescriptionWindObsItem wind={wind} />
            {isNotNullOrUndefined(pressureValue) && (
              <ListInlineIconItem v={1} icon="pressure" title="Pressure">
                <span>{`${pressureValue}hPa`}</span>
              </ListInlineIconItem>
            )}
            {isNotNullOrUndefined(wind?.gustSpeed) && (
              <ListInlineIconItem v={1} icon="gust" title="Gust">
                <span>{`${wind?.gustSpeed}km/h`}</span>
              </ListInlineIconItem>
            )}
            <StationDescriptionSoilMoistureItem value={value} />
            <StationDescriptionSoilTemperatureItem value={value} />
          </div>
          {issuedAt && (
            <small className="fineprint u-block u-textGrey u-mT-sm">
              Issued <DisplayTime date={issuedAt.toString()} />
            </small>
          )}
          <div className="u-textGrey fineprint u-mB-sm u-pT-sm">
            <Reference image={attribution?.image} text={attribution?.text} url={attribution?.url} maxHeight={1.5} />
          </div>

          {weatherStationUrl && <LinkRef link={{ url: weatherStationUrl, label: 'View all data for this station' }} />}
        </div>
      </Tile>
    );
  }
};
